module.exports = "import React from 'react';\nimport BrandBand from '~/components/brand-band'; // `~` is replaced with design-system-react at runtime\n\nclass Example extends React.Component {\n\trender() {\n\t\treturn (\n\t\t\t<BrandBand\n\t\t\t\tid=\"brand-band-no-image\"\n\t\t\t\timage=\"none\"\n\t\t\t\tstyle={{ zIndex: 1, backgroundColor: '#eef4ff' }}\n\t\t\t/>\n\t\t);\n\t}\n}\n\nExample.displayName = 'BrandBandExample';\n\nexport default Example; // export is replaced with `ReactDOM.render(<Example />, mountNode);` at runtime\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/@salesforce/design-system-react/components/brand-band/__examples__/no-image.jsx
// module id = 767
// module chunks = 0